module.exports = __webpack_public_path__ + "img/icon-dinners-club.2add4017.svg";